<template>
    <el-tooltip :disabled="!showTip" effect="dark" :content="content.toString()" placement="top-start">
        <div class="parent-box">
            <p class="text-overlow-box" :class="uuid">{{ content }}</p>
        </div>
    </el-tooltip>
</template>

<script>
    export default {
        props:{
            content:{
                require:true,
                type:[String,Number],
                default:'',
            },
        },
        data(){
            return{
                showTip:false,
                uuid:this.uuid8()
            }
        },
        methods:{
            uuid8() {
                const letters = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
                const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
                let uuid = letters[Math.floor(Math.random() * letters.length)]; // 首位必须是字母
                for (let i = 1; i < 8; i++) {
                    uuid += chars[Math.floor(Math.random() * chars.length)];
                }
                return uuid;
            },
            monitorContent(){
                let container=document.querySelector('.'+this.uuid);
                if(!container)return;
                let scroll=container.scrollWidth;
                let client=container.clientWidth;
                if(scroll>client){
                    this.showTip=true;
                }else{
                    this.showTip=false;
                }
            },
        },
        watch:{
            content:{
                handler(){
                    this.monitorContent();
                },
            }
        },
        mounted(){
            this.monitorContent();
            window.addEventListener('resize',this.monitorContent);
        },
        destroyed(){
            window.removeEventListener('resize',this.monitorContent);
        }
    }
</script>

<style lang="less" scoped>
.parent-box{
    width: 100%;
    display: flex;
    align-items: center;
    overflow: hidden;
}
.text-overlow-box{
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
</style>